// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { init as initPlausible } from "@plausible-analytics/tracker"

// Privacy-friendly analytics by Plausible, bundled rather than loaded from
// plausible.io so the tracker itself survives blocklists. Pageviews are
// captured automatically, including Turbo Drive navigations, which the tracker
// picks up by patching history.pushState. Localhost is ignored by default.
initPlausible({
  domain: "aplo.studio",
  outboundLinks: true,
  fileDownloads: true
})
